import { ChatMessage, ChatParticipant } from '@prisma/client'
import { useEffect } from 'react'
import { Api } from '~/core/trpc'
import { useChatContext } from '../../../context/chat.context'

type Props = {
  conversationId: string
  participant: ChatParticipant
  messageLast: ChatMessage
}

export const useTrackMessageRead = ({
  conversationId,
  participant,
  messageLast,
}: Props) => {
  const { refresh } = useChatContext()

  const updateMessageMutation = Api.chatParticipant.update.useMutation()

  const reset = async () => {
    try {
      await updateMessageMutation.mutateAsync({
        where: {
          id: participant.id,
        },
        data: {
          countUnreadMessages: 0,
        },
      })

      refresh()
    } catch (error) {
      console.error('Unknown Error', error)
    }
  }

  useEffect(() => {
    if (!conversationId || !participant) {
      return
    }

    const canReset = (participant.countUnreadMessages ?? 0) > 0

    if (canReset) {
      reset()
    }
  }, [conversationId, participant, messageLast])
}
